import { Serializable } from '@admin/core/models/serializable';
import { EmailSmsTemplateModel } from './email-sms-template-model';

export class EmailSmsTemplateDataModel
  implements Serializable<EmailSmsTemplateDataModel>
{
  fromObject(object: any): EmailSmsTemplateDataModel {
    Object.assign(this, object);
    this.emailTemplates = [];
    this.smsTemplates = [];

    if (
      object.emailTemplates &&
      object.emailTemplates.length &&
      object.emailTemplates.length > 0
    ) {
      object.emailTemplates.forEach((el) => {
        let t = new EmailSmsTemplateModel();
        t = t.fromObject(el);
        this.emailTemplates.push(t);
      });
    }

    if (
      object.smsTemplates &&
      object.smsTemplates.length &&
      object.smsTemplates.length > 0
    ) {
      object.smsTemplates.forEach((el) => {
        let t = new EmailSmsTemplateModel();
        t = t.fromObject(el);
        this.smsTemplates.push(t);
      });
    }

    return this;
  }

  toObject() {
    return {
      EmailTemplates: this.emailTemplates,
      SmsTemplates: this.smsTemplates,
    };
  }

  public emailTemplates: EmailSmsTemplateModel[];
  public smsTemplates: EmailSmsTemplateModel[];

  constructor() {
    this.emailTemplates = [];
    this.smsTemplates = [];
  }
}
